import { __module as a } from "./index88.mjs";
var h;
function c() {
  return h ? a.exports : (h = 1, (function() {
    var f = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/", u = {
      // Bit-wise rotation left
      rotl: function(r, t) {
        return r << t | r >>> 32 - t;
      },
      // Bit-wise rotation right
      rotr: function(r, t) {
        return r << 32 - t | r >>> t;
      },
      // Swap big-endian to little-endian and vice versa
      endian: function(r) {
        if (r.constructor == Number)
          return u.rotl(r, 8) & 16711935 | u.rotl(r, 24) & 4278255360;
        for (var t = 0; t < r.length; t++)
          r[t] = u.endian(r[t]);
        return r;
      },
      // Generate an array of any length of random bytes
      randomBytes: function(r) {
        for (var t = []; r > 0; r--)
          t.push(Math.floor(Math.random() * 256));
        return t;
      },
      // Convert a byte array to big-endian 32-bit words
      bytesToWords: function(r) {
        for (var t = [], n = 0, o = 0; n < r.length; n++, o += 8)
          t[o >>> 5] |= r[n] << 24 - o % 32;
        return t;
      },
      // Convert big-endian 32-bit words to a byte array
      wordsToBytes: function(r) {
        for (var t = [], n = 0; n < r.length * 32; n += 8)
          t.push(r[n >>> 5] >>> 24 - n % 32 & 255);
        return t;
      },
      // Convert a byte array to a hex string
      bytesToHex: function(r) {
        for (var t = [], n = 0; n < r.length; n++)
          t.push((r[n] >>> 4).toString(16)), t.push((r[n] & 15).toString(16));
        return t.join("");
      },
      // Convert a hex string to a byte array
      hexToBytes: function(r) {
        for (var t = [], n = 0; n < r.length; n += 2)
          t.push(parseInt(r.substr(n, 2), 16));
        return t;
      },
      // Convert a byte array to a base-64 string
      bytesToBase64: function(r) {
        for (var t = [], n = 0; n < r.length; n += 3)
          for (var o = r[n] << 16 | r[n + 1] << 8 | r[n + 2], e = 0; e < 4; e++)
            n * 8 + e * 6 <= r.length * 8 ? t.push(f.charAt(o >>> 6 * (3 - e) & 63)) : t.push("=");
        return t.join("");
      },
      // Convert a base-64 string to a byte array
      base64ToBytes: function(r) {
        r = r.replace(/[^A-Z0-9+\/]/ig, "");
        for (var t = [], n = 0, o = 0; n < r.length; o = ++n % 4)
          o != 0 && t.push((f.indexOf(r.charAt(n - 1)) & Math.pow(2, -2 * o + 8) - 1) << o * 2 | f.indexOf(r.charAt(n)) >>> 6 - o * 2);
        return t;
      }
    };
    a.exports = u;
  })(), a.exports);
}
export {
  c as __require
};
